import { DeviceType } from '@/app/util/env'
import { cn } from '@/util/cn'
import { ReactNode } from 'react'
import NavButtons from './nav-button'

const scrollerClassName =
    'no-scrollbar group/scroller flex flex-nowrap gap-2 overflow-x-auto overflow-y-hidden scroll-smooth md:overflow-x-hidden'

type Props = {
    height?: number
    width: number
    className?: string
    children: ReactNode
    elementId: string
    deviceType: DeviceType
}
function ScrollCarousel({ children, className = '', height, width, elementId, deviceType }: Props) {
    return (
        <div className={cn(`group/container relative`, className)} style={{ height }}>
            <div className={scrollerClassName} id={elementId}>
                {children}
            </div>
            {deviceType === 'desktop' && (
                <NavButtons
                    width={width}
                    iconClassName="none md:block opacity-0 group-hover/container:opacity-100"
                    elementId={elementId}
                />
            )}
        </div>
    )
}

export default ScrollCarousel
